import React, { forwardRef } from "react";
import { ReactNode } from "react";
import { TypeRampV2Props } from "../../typography";
import { ChipLabelStyled } from "../styled/ChipLabelStyled";
import { SharedChipProps } from "../types";

const chipLabelTypeRampTheme = {
    medium: "Inter--12px--500w",
    small: "Inter--10px--500w",
} as const;

export interface ChipLabelProps extends Pick<TypeRampV2Props, "omitTooltip"> {
    children: ReactNode;
    size: Exclude<SharedChipProps["size"], undefined>;
}

export const ChipLabel = forwardRef<HTMLSpanElement, ChipLabelProps>(({ children, omitTooltip, size }, ref) => {
    return (
        <ChipLabelStyled
            // Lodestar and Ursa Chips both use the same font styles.
            system="ursa"
            variant={chipLabelTypeRampTheme[size]}
            omitTooltip={omitTooltip}
            lineClamp={1}
            ref={ref}
        >
            {children}
        </ChipLabelStyled>
    );
});

ChipLabel.displayName = "ChipLabel";
